import type { ReactNode } from "react";
import { Outlet } from "react-router";
import { SiteHeader } from "@/components/shared/site-header";
import { RequireAuth } from "@/features/auth/components/route-guards";
import { sessionDisplayName, useSession } from "@/features/auth/hooks/use-session";
import { useApplyPendingStudyProfile } from "@/features/plan/pending-study-profile";

/**
 * Every signed-in student page: any authenticated user may enter (no role
 * check — exam-taking is the default experience, not a privileged one).
 * Signed-out visitors are sent to /login before any page renders, and the
 * page's own API calls are independently protected server-side.
 */
export function StudentLayout() {
  return (
    <RequireAuth>
      <StudentChrome />
    </RequireAuth>
  );
}

/** The signed-in header + content area; `children` replaces the route outlet (used by /pricing). */
export function StudentChrome({ children }: { children?: ReactNode }) {
  const { data: user } = useSession();
  // Answers from the "Shaxsiy reja" questionnaire filled in before signing up are saved on the first signed-in page.
  useApplyPendingStudyProfile(Boolean(user));
  return (
    <div className="flex min-h-full flex-1 flex-col">
      <SiteHeader inApp user={user ? { displayName: sessionDisplayName(user), role: user.role } : null} />
      <main className="flex-1">
        {children ?? <Outlet />}
      </main>
    </div>
  );
}
